import React, { createContext } from "react";

export type ContextProviderType = {
  ref: null | React.RefObject<HTMLDivElement>;
};

const ScrollContainerContext = createContext<ContextProviderType>({
  ref: null,
});

export const ScrollContainerContextProvider = ScrollContainerContext.Provider;

export default ScrollContainerContext;
